<form [formGroup]="postingForm()">
  <div layout-horizontal>
    <div layout-verical layout-flex-1>
      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.location' | translate }}
        </rt-label>
        <rt-select
          formControlName="locationId"
          [options]="locationOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        />
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.employment_type' | translate }}
        </rt-label>
        <rt-select
          formControlName="employmentType"
          [options]="employmentTypeOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        />
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.feature' | translate }}
        </rt-label>
        <rt-select
          formControlName="feature"
          [options]="featureOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        />
      </rt-form-field>

      <rt-form-field>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.weekly_hours' | translate }}
        </rt-label>
        <div class="weekly-hours" layout-horizontal>
          <rt-label>
            {{ 'rti.hotelprofessionals.create_posting.modal.weekly_hours_min' | translate }}
          </rt-label>
          <rt-input
            variant="rounded"
            type="number"
            [value]="postingForm().controls.weeklyHoursMin.value"
            (valueChange)="
              postingForm().controls.weeklyHoursMin.markAsDirty();
              postingForm().controls.weeklyHoursMin.setValue($event)
            "
            (blur)="ensureValidHours()"
          />
          <rt-label>
            {{ 'rti.hotelprofessionals.create_posting.modal.weekly_hours_max' | translate }}
          </rt-label>
          <rt-input
            variant="rounded"
            type="number"
            [value]="postingForm().controls.weeklyHoursMax.value"
            (valueChange)="
              postingForm().controls.weeklyHoursMax.markAsDirty();
              postingForm().controls.weeklyHoursMax.setValue($event)
            "
            (blur)="ensureValidHours()"
          />
        </div>
      </rt-form-field>
    </div>

    <div layout-verical layout-flex-1 margin-left>
      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.education' | translate }}
        </rt-label>
        <rt-select
          formControlName="education"
          [options]="educationOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        />
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.experience' | translate }}
        </rt-label>
        <rt-select
          formControlName="experience"
          [options]="experienceOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        />
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.hotelprofessionals.create_posting.modal.salary' | translate }}
        </rt-label>
        <rt-input
          variant="rounded"
          [placeholder]="
            'rti.hotelprofessionals.create_posting.modal.salary_placeholder' | translate
          "
          formControlName="salary"
        />
      </rt-form-field>
    </div>
  </div>

  <rt-divider variant="line" margin-tb />

  <rt-form-field [required]="!postingForm().controls.departments.value.length" margin-bottom>
    <rt-label>
      {{ 'rti.hotelprofessionals.create_posting.modal.departments' | translate }}
    </rt-label>
    <rti-simple-multiselect
      [control]="$any(postingForm().controls.departments)"
      [options]="departmentOptions"
    />
  </rt-form-field>

  <rt-form-field [required]="!postingForm().controls.functions.value.length" margin-bottom>
    <rt-label>
      {{ 'rti.hotelprofessionals.create_posting.modal.functions' | translate }}
    </rt-label>
    <rti-simple-multiselect
      [control]="$any(postingForm().controls.functions)"
      [options]="functionOptions"
    />
  </rt-form-field>

  <rt-form-field [required]="!postingForm().controls.requiredLanguages.value.length" margin-bottom>
    <rt-label>
      {{ 'rti.hotelprofessionals.create_posting.modal.required_languages' | translate }}
    </rt-label>
    <rti-simple-multiselect
      [control]="$any(postingForm().controls.requiredLanguages)"
      [options]="requiredLanguageOptions"
    />
  </rt-form-field>
</form>
